import { ProductType } from '@inter-ikea-storageone/range';
/**
 * The mesh and metal basket assemblies had another structure in old PAX definition,
 * and the part keys were differently named. We need to fix the partKey name to match
 * the new structure.
 */
export class OldBasketAssemblyInterceptor {
    constructor(marketProducts) {
        this.meshBasketRails = marketProducts
            .filter(p => p.type === ProductType.PAX_MESH_BASKET_RAIL)
            .map(p => p.coreProductId);
    }
    beforeDeserialize(json) {
        const data = JSON.parse(json);
        const entities = data.entities;
        const replacedEntities = entities?.map((entity) => {
            if (this.meshBasketRails.includes(entity.ref)) {
                let components = entity.c;
                if (components?.ProductPartComponent) {
                    components = {
                        ...components,
                        ProductPartComponent: {
                            partKey: components.ProductPartComponent.partKey
                                .replace('rail-1', 'rail-left')
                                .replace('rail-2', 'rail-right')
                        }
                    };
                }
                return { ...entity, c: components };
            }
            return entity;
        });
        return JSON.stringify({ ...data, entities: replacedEntities });
    }
    beforeParsingComponents() { }
    beforeBuildingEntities() { }
    afterDeserializeComplete() { }
}
//# sourceMappingURL=OldBasketAssemblyInterceptor.js.map